/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_TitleInputs */

const es_privacy_policy_data_collected_title = /** @type {(inputs: Privacy_Policy_Data_Collected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Informacion que Recopilamos`)
};

const en_privacy_policy_data_collected_title = /** @type {(inputs: Privacy_Policy_Data_Collected_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Information We Collect`)
};

/**
* | output |
* | --- |
* | "3. Information We Collect" |
*
* @param {Privacy_Policy_Data_Collected_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_title = /** @type {((inputs?: Privacy_Policy_Data_Collected_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_title(inputs)
	return en_privacy_policy_data_collected_title(inputs)
});
export { privacy_policy_data_collected_title as "privacy_policy.data_collected.title" }